import moment from "moment";
export var PARTIAL_DATE_PLACEHOLDER = "DD.MM.RRRR / MM.RRRR / RRRR";
/** Display date format used by Stripes Datepicker (dateFormat prop). */
export var DISPLAY_DATE_FORMAT = "DD/MM/YYYY";
/** API date format expected by the backend. */
export var API_DATE_FORMAT = "YYYY-MM-DD";
/**
 * Formats a date string to "DD/MM/YYYY" format.
 * If the input is falsy, returns an empty string.
 *
 * @param date - The date string to format.
 * @returns The formatted date string or an empty string.
 */
export var formatDate = function (date) {
    return date ? moment(date).format(DISPLAY_DATE_FORMAT) : "";
};
/**
 * Converts a display-format date (DD/MM/YYYY) to API format (YYYY-MM-DD).
 * Returns undefined if the input is falsy.
 *
 * @param date - The date string in DD/MM/YYYY format.
 * @returns The date in YYYY-MM-DD format or undefined.
 */
export var toApiDate = function (date) {
    return date ? moment(date, DISPLAY_DATE_FORMAT).format(API_DATE_FORMAT) : undefined;
};
/** Time zone the agency works in; record timestamps are shown in it regardless of the browser. */
export var DISPLAY_TIME_ZONE = "Europe/Prague";
var dateTimePartsFormatter = new Intl.DateTimeFormat("cs-CZ", {
    timeZone: DISPLAY_TIME_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
});
/**
 * Formats an ISO-8601 instant as "DD.MM.YYYY HH:mm" in Europe/Prague (the project's
 * date-time pattern of adminJobUtils.formatDateTime, but pinned to Europe/Prague instead of
 * the browser zone and empty instead of "-" for a missing value).
 * Returns an empty string for a missing or unparsable value, so a table cell stays empty.
 *
 * @param iso - The ISO-8601 instant, e.g. "2026-10-16T12:05:00Z".
 * @returns The formatted date and time or an empty string.
 */
export var formatPragueDateTime = function (iso) {
    if (!iso)
        return "";
    var date = new Date(iso);
    if (Number.isNaN(date.getTime()))
        return "";
    var parts = Object.fromEntries(dateTimePartsFormatter
        .formatToParts(date)
        .map(function (part) { return [part.type, part.value]; }));
    return "".concat(parts.day, ".").concat(parts.month, ".").concat(parts.year, " ").concat(parts.hour, ":").concat(parts.minute);
};
